import { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useContent, mediaUrl } from "../context/ContentContext";
import { Equalizer } from "./Motion";

const NAV_FALLBACK = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/music", label: "Music" },
  { to: "/videos", label: "Videos" },
  { to: "/news", label: "News" },
  { to: "/events", label: "Events" },
  { to: "/mvn-nation", label: "MVN Nation" },
  { to: "/epk", label: "EPK" },
  { to: "/booking", label: "Booking" },
  { to: "/contact", label: "Contact" },
];

export const Navbar = () => {
  const c = useContent();
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();
  const NAV = (Array.isArray(c.nav) && c.nav.length ? c.nav : NAV_FALLBACK)
    .filter((n) => n.visible !== false)
    .map((n) => ({ to: n.to, label: n.label }));

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  useEffect(() => { setOpen(false); }, [pathname]);

  const presave = c.links?.foreverPresave || "#";

  return (
    <header data-testid="main-navbar" className={`fixed top-0 inset-x-0 z-50 transition-colors duration-500 ${scrolled ? "bg-black/70 backdrop-blur-xl border-b border-white/10" : "bg-transparent"}`}>
      <nav className="max-w-7xl mx-auto px-5 sm:px-8 h-20 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3 group">
          {c.media?.epkLogo && <img src={mediaUrl(c.media.epkLogo)} alt="MVN NATION" className="h-9 w-auto" />}
          <span className="hidden sm:block font-display text-2xl tracking-wide text-white">{c.artist?.name}</span>
          <Equalizer className="hidden sm:flex ml-1 opacity-80" />
        </Link>
        <div className="hidden xl:flex items-center gap-x-6">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} data-testid={`nav-link-${n.label.toLowerCase().replace(/[^a-z]/g, "-")}`}
              className={({ isActive }) => `text-[11px] uppercase tracking-[0.16em] transition-colors duration-300 hover:text-amberwarm ${isActive ? "text-amberwarm" : "text-white/70"}`}>
              {n.label}
            </NavLink>
          ))}
        </div>
        <div className="flex items-center gap-3">
          <a href={presave} target="_blank" rel="noreferrer" data-testid="nav-presave-btn"
            className="hidden sm:inline-flex items-center rounded-full bg-amberwarm px-5 py-2.5 text-xs font-semibold uppercase tracking-wider text-black transition-transform duration-300 hover:scale-105 shadow-[0_0_24px_rgba(245,158,11,0.35)]">
            Pre-save FOREVER
          </a>
          <button data-testid="mobile-menu-toggle" onClick={() => setOpen((v) => !v)} className="xl:hidden text-white p-2" aria-label="Menu">
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </nav>
      {open && (
        <div data-testid="mobile-menu" className="xl:hidden bg-black/95 backdrop-blur-xl border-t border-white/10 max-h-[80vh] overflow-y-auto">
          <div className="flex flex-col px-6 py-6 gap-4">
            {NAV.map((n) => (
              <NavLink key={n.to} to={n.to} data-testid={`mobile-nav-${n.label.toLowerCase().replace(/[^a-z]/g, "-")}`}
                className={({ isActive }) => `font-display text-3xl ${isActive ? "text-amberwarm" : "text-white"}`}>{n.label}</NavLink>
            ))}
            <a href={presave} target="_blank" rel="noreferrer" className="mt-2 inline-flex items-center justify-center rounded-full bg-amberwarm px-5 py-3 text-sm font-semibold uppercase tracking-wider text-black">Pre-save FOREVER</a>
          </div>
        </div>
      )}
    </header>
  );
};
